"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    A: ()=>A
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_slot_namespaceObject = require("@radix-ui/react-slot");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_A_variants_cjs_namespaceObject = require("./A.variants.cjs");
function A({ asChild, children, className, iconLeft, iconRight, ...props }) {
    const { buttonSlot, textSlot, iconSlot } = (0, external_A_variants_cjs_namespaceObject.aVariants)(props);
    const classes = (0, index_cjs_namespaceObject.cn)(buttonSlot(), className);
    const iconSlotClasses = iconSlot();
    const iconSize = 'sm' === props.size || 'md' === props.size ? '20' : '24';
    const Comp = asChild ? react_slot_namespaceObject.Slot : 'a';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(Comp, {
        className: classes,
        ...(0, index_cjs_namespaceObject.cleanProps)(props, [
            'shadow',
            'fullWidth',
            'drop-shadow'
        ]),
        children: [
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                className: iconSlotClasses,
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_slot_namespaceObject.Slottable, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                    className: textSlot(),
                    children: children
                })
            }),
            iconRight && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                className: iconSlotClasses,
                iconName: iconRight,
                size: iconSize
            })
        ]
    });
}
exports.A = __webpack_exports__.A;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "A"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
